<template>
  <div>
    <h1>Admin: Benutzer</h1>

    <b-alert
      v-model="showAlert"
      class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      variant="success"
      fade
      dismissible
    >
      {{alertMessage}}
    </b-alert>

    <button class="btn btn-primary" v-on:click="createEmptyUser()" style="margin-bottom: 10px;float:right;"><font-awesome-icon icon="user-plus" /> Neuer Benutzer</button>
    <table class="table table-bordered table-striped table-small">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>KundenNr</th>
          <th>Shop</th>
          <th>Marge</th>
          <th>Passwort</th>
          <th>Master</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="user_item in userListing" :key="user_item.id">
          <td>{{user_item.id}}</td>
          <td><input v-model="user_item.name" placeholder="Name" class="form-control"></td>
          <td><input v-model="user_item.user_number" placeholder="KundenNr" class="form-control"></td>
          <td>
            <select v-model="user_item.shop_ids" class="form-control">
                <option disabled value="">Please select one</option>
                <option v-for="shop in shopListing" :key="shop.id" :value="shop.id">{{shop.id}} - {{shop.name}}</option>
            </select>
          </td>
          <td><input v-model="user_item.margin_percentage" placeholder="%" class="form-control"></td>
          <td><input v-model="user_item.password" placeholder="Passwort" class="form-control"></td>
          <td>{{user_item.master}}</td>
          <td>
              <button class="btn btn-primary" v-on:click="saveUser(user_item)">
                <font-awesome-icon icon="save" />
              </button>
              <button class="btn btn-warning" v-on:click="deleteUser(user_item)">
                <font-awesome-icon icon="trash" />
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
const request = require('superagent')

export default{
  name: 'AddminUsers',
  data() {
    return {userListing: [],shopListing: [],showAlert: false,alertMessage: "",api_token:""};
  },
  computed: {
  },
  mounted: function () {
    this.api_token = localStorage.getItem('API_TOKEN')

    this.fetchData();
  },
  methods: {
      fetchData: function(){
            var that = this
            request
            .get(process.env.API_HOST + '/api/users/')
            .set('Authorization',this.api_token)
            .set('Accept', 'application/json')
            .then(function (res) {
                that.userListing = res.body
            })

            request
            .get(process.env.API_HOST + '/api/shops')
            .set('Accept', 'application/json')
            .set('Authorization',this.api_token)
            .then(function (res) {
                that.shopListing = res.body
            })
      },
      saveUser: function(user){
        var that = this

        request
        .put(process.env.API_HOST + '/api/users/'+user.id)
        .send({user: {name: user.name, 
                user_number: user.user_number,
                margin_percentage: user.margin_percentage,
                shop_ids: user.shop_ids,
                password: user.password,
                master: user.master}})
        .set('Accept', 'application/json')
        .set('Authorization',this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Benutzer " + user.name + " wurde gespeichert!";
            that.showAlert = true;
        })
      },
      deleteUser: function(user){
        var check = confirm('Den Benutzer ' + user.name + " wirklich löschen?"); 
	    if (check == false) {
		    return;
        }
        
        var that = this

        request
        .delete(process.env.API_HOST + '/api/users/'+user.id)
        .set('Accept', 'application/json')
        .set('Authorization',this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Benutzer " + user.name + " wurde gelöscht!";
            that.showAlert = true;
        })
      },
      createEmptyUser: function(){
        var that = this

        request
        .post(process.env.API_HOST + '/api/users')
        .send({user: {name: 'Neuer Benutzer', 
                user_number: 0,
                margin_percentage: 0,
                password: 'passwort',
                master: 0}})
        .set('Accept', 'application/json')
        .set('Authorization',this.api_token)
        .then(function (res) {
            that.fetchData();
            that.alertMessage = "Neuer Benutzer wurde in der Liste unten hinzugefügt.";
            that.showAlert = true;
        })
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/AdminUsers.vue